import { API_BASE_URL } from './config';

export interface ProfileResponse {
  id: string;
  email: string;
  displayName: string;
}

/** Fetch the current user's profile from the backend. */
export async function getProfile(accessToken: string): Promise<ProfileResponse> {
  const response = await fetch(`${API_BASE_URL}/api/v1/me`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  if (!response.ok) {
    throw new Error('Failed to load profile');
  }
  return response.json();
}

/** Update the current user's display name (Cognito + local DB). */
export async function updateDisplayName(
  accessToken: string,
  displayName: string
): Promise<ProfileResponse> {
  const response = await fetch(`${API_BASE_URL}/api/v1/me/name`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({ displayName }),
  });
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data?.message || 'Failed to update name');
  }
  return response.json();
}
